const doiFinder = {
    props:{
        placeholder: "",
        injectedValue: "",
        minCharacters: {
            type: Number,
            default: 3,
        },
        handler: {
            type: String,
            default: "",
        },
        greReady: false,
        captchaSiteKey: "",
        captchaAction: ""
    },
    template:`
    <div class="doi-finder">
        <div class="form-floating">
            
            <transition name="fade">
                <div v-if="loading" class="doi-finder__loader">
                    <div class="circle-loader"></div>
                </div>
            </transition>

            <slot name="default" :updateInput="updateInput"></slot>
            
            <b-auto-completer ref="autocompleter" v-show="handler!=='' && startSearch"
                :clickable="true"
                :handler="handler" 
                :value="value"
                :gre-ready="greReady"
                :captcha-site-key="captchaSiteKey"
                :captcha-action="captchaAction"
                :useCaptcha="true"
                @clicked="autocompleteClicked"
                @searchFailed="searchFailed"
                @searchCompleted="searchCompleted"
                @noData="noSearchData">
            </b-auto-completer>
            
            <div class="address-finder__bottom">
                <slot name="validation" :errorSearchData="errorSearchData"></slot>
            </div>
            
        </div>
    </div>
    `,
    data() {
        return {
            debounceTimer:0,
            value: "",
            loading: false,
            startSearch: false,
            records: [],
            errorMsgs: [],
            errorSearchData: false
        }
    },
    created(){
        this.value = this.injectedModel
    },
    methods:{
        updateInput(e){
            this.value = e.target.value
            this.errorSearchData = false
            clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
                if (this.value.length >= this.minCharacters) {
                    this.loading = true
                    this.startSearch = true;
                    this.$refs["autocompleter"].doSearch()
                } else {
                    
                }
            }, 500);
        },
        autocompleteClicked(item){
            this.value = item.id
            this.$emit("autocompleteClicked", item, item.id)
            this.startSearch = false;
        },
        
        noSearchData(){
            this.errorSearchData = true
            this.loading = false
        },
        searchFailed(){
            this.loading = false
        },
        searchCompleted(){
            this.loading = false
        },
    }
}